import { RoleManagementAccessControl } from 'domains/role-management/access-control/roleManagementAccess.configuration'
import { useDomainAccessControl } from 'domains/role-management/utils/domain/accessControl'
import { useContext } from 'react'
import { WarehouseContext } from 'utils/contexts/warehouse/WarehouseContext'

export const useHasRoleManagementAccess = () => {
  const warehouseContext = useContext(WarehouseContext)
  const hasAccess = useDomainAccessControl()

  // If we don't have the ability to check on the users permissions,
  // (because we are in a place where the warehouse context is not available)
  // then lets be safe and assume the user does not have access.
  if (!warehouseContext) return false

  // Requires warehouse context to be loaded.
  // Not loaded on the Admin panel pages.
  return hasAccess(RoleManagementAccessControl)
}
